import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbRunning {
  id: number
  level: string
  ordering: number
  active: string
  max_bpm?: number
  min_bpm?: number
  image?: string
  bpm_image?: string
  wide_img?: string
  spotlight_img?: string
}
export interface NbRunningsResponse {
  success: boolean
  runnings: NbRunning[]
}

export interface NbRunningResponse {
  success: boolean
  running: NbRunning
}

export interface NbRunningSuccessResponse {
  success: boolean
}

interface NbDj {
  id: any
  name: any
  follow: any
  image: any
  isFavorite: any
  plays: any
  thumbnail: any
  twitter: any
}

export interface NbMix {
  id: any
  Dj?: NbDj
}

export interface NbCategoryMixesList {
  mixes: NbMix[]
}

export interface NbRunningMixesList {
  level: NbRunning
  categories: NbCategoryMixesList
}

export interface NbRunningMixesListResponse {
  success: boolean
  levels?: NbRunningMixesList[]
  reason?: string
}

@Injectable()
export class RunningService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/running/`

  constructor(private http: HttpClient) {}

  public getAllRunnings(): Observable<NbRunningsResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}get`)
      .map(res => res as NbRunningsResponse)
  }

  public getRunningByID(id: number): Observable<NbRunningResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getrunning/id/${id}`)
      .map(res => res as NbRunningResponse)
  }

  public getRunningMixes(): Observable<NbRunningMixesListResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getrunningmixes`)
      .map(res => res as NbRunningMixesListResponse)
  }

  public saveRunning(running: NbRunning): Observable<NbRunningResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}save`, running)
      .map(res => res as NbRunningResponse)
  }

  public saveOrder(runnings: NbRunning[]): Observable<any> {
    return this.http
      .post(`${this.API_ENDPOINT}saveorder`, runnings)
      .map(res => res as any)
  }

  public deleteRunning(id: number): Observable<NbRunningSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}delete/id/${id}`)
      .map(res => res as NbRunningSuccessResponse)
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/data/running.service.ts